import jwtDecode from "jwt-decode";

const sessionVar = "PORTAL_SES";
const sessionVarUser = "PORTAL_USER";

const SessionService = {
  save(data) {
    localStorage.setItem(sessionVar, JSON.stringify(data));
    location.reload();
  },
  session() {
    return JSON.parse(localStorage.getItem(sessionVar) || "{}");
  },
  logout() {
    localStorage.removeItem(sessionVar);
    location.reload();
  },
  isLogged() {
    const data = localStorage.getItem(sessionVar);
    return data !== null;
  },
  setUser(data) {
    localStorage.setItem(sessionVarUser, JSON.stringify(data));
  },
  getUser() {
    const data = jwtDecode(this.session().token);
    const properties =
      data["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"];
    if (properties) {
      return JSON.parse(properties);
    }
    return null;
  }
};

export default SessionService;
